import { render, staticRenderFns } from "./PricesCardPav.vue?vue&type=template&id=80dc9c7c&"
import script from "./PricesCardPav.vue?vue&type=script&lang=js&"
export * from "./PricesCardPav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports